import { handleActions } from 'redux-actions';
import { SET_LANGUAGE } from 'constants/ActionTypes';

import en from 'constants/language/en.json';
import is from 'constants/language/is.json';

const initialState = {
  language: localStorage.language || 'is',
  messages: is,
};

// handleActions is a helper function to instead of using a switch case statement,
// we just use the regular map with function state attach to it.

export default handleActions({
  [SET_LANGUAGE]: (state, { language }) => ({
    ...state,
    language,
    messages: language === 'en' ? en : is,
  }),
}, initialState);



// WEBPACK FOOTER //
// ./src/reducers/languageReducer.js